import { getRequest } from '../utils/axios';
import { buildUrlParams } from '../utils/urls';

export const categoriesService = {
  getCategories: (onSuccess, onError, params = {}) => {
    const url = '/api/v1/categories/' + buildUrlParams(params);

    getRequest(
      url,
      (response) => {
        if (onSuccess) {
          return onSuccess(response);
        }
      },
      (error, response) => {
        if (onError) {
          return onError(error, response);
        }
      }
    );
  },

  /** GET /api/v1/categories/suggestions/ — brand-based embedding suggestions */
  getCategorySuggestions: (onSuccess, onError, params = {}) => {
    const url = '/api/v1/categories/suggestions/' + buildUrlParams(params);

    getRequest(
      url,
      (response) => {
        if (onSuccess) {
          return onSuccess(response);
        }
      },
      (error, response) => {
        if (onError) {
          return onError(error, response);
        }
      }
    );
  },
};

